import flatten from './flatten';

export default flatten;
